import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Pagination } from "../../shared/pagination.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { PagingResponseModel } from "../../shared/api-response.model";
import { Core2Config } from "../../shared/core2Config";

import { ApiVisa } from "../../shared/api-visa.model";
import { Observable } from "rxjs";
import { StockReplenishmentModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment.model";

@Injectable({ providedIn: "root" })
export class StockReplenishmentService extends BaseApiTemplateService<StockReplenishmentModel> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    "erp/inv-stock-replenishment-algos/backoffice-ep";

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/inv-stock-replenishment-algos/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      "erp/inv-stock-replenishment-algos/backoffice-ep";
    this.httpClient = theHttp;
  }

  public getStockReplenishment(
    apiVisa: ApiVisa
  ): Observable<StockReplenishmentModel> {
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem("authToken"),
      tenantCode: localStorage.getItem("tenantCode"),
    });

    const options = {
      headers: headers,
    };

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }

    return this.httpClient.get<StockReplenishmentModel>(this.url, options);
  }

  public getStockReplenishmentByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<StockReplenishmentModel> {
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem("authToken"),
      tenantCode: localStorage.getItem("tenantCode"),
    });

    const options = {
      headers: headers,
    };

    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    return this.httpClient.get<StockReplenishmentModel>(
      this.url + "/" + guid,
      options
    );
  }

  public saveStockReplenishment(
    stockReplenishment: StockReplenishmentModel,
    apiVisa: ApiVisa
  ): Observable<StockReplenishmentModel> {
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem("authToken"),
      tenantCode: localStorage.getItem("tenantCode"),
    });

    const options = {
      headers: headers,
    };

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }

    return this.httpClient.put<StockReplenishmentModel>(this.url, options);
  }

  public deleteStockReplenishment(
    guid: string,
    apiVisa: ApiVisa
  ): Observable<StockReplenishmentModel> {
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem("authToken"),
      tenantCode: localStorage.getItem("tenantCode"),
    });

    const options = {
      headers: headers,
    };

    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    
    return this.httpClient.delete<StockReplenishmentModel>(
      this.url + "/" + guid,
      options
    );
  }
}
